import http from './../http.interceptor.js';
 

export function songSheet(params) {
	return http.get('/v3.home/songSheet', params)
}
